<template>
  <div class="user-courses-container wrapper">
    <div class="user-courses-empty-box" v-if="truelyEmpty">
      <picture class="imgbox">
        <source srcset="@/assets/img/comet/user/courseempty@2x.png?x-oss-process=image/format,webp" type="image/webp">
        <img src="@/assets/img/comet/user/courseempty@2x.png">
      </picture>
      <p>It seems that you haven't bought any course.</p>
    </div>
    <div v-else>
      <ul>
        <li
          v-for="item in myCourses"
          :key="item.goods_id"
          @click="goCourseDetail(item)"
          class="user-courses-item">
          <div class="user-courses-item-img">
            <img :src="item.cover" alt="">
          </div>
          <div class="user-courses-item-infos">
            <div class="user-courses-item-status">
              <div
                :class="{
                  notstart: item.live_broadcast_state === 2,
                  half: item.live_broadcast_state === 1,
                  total: item.live_broadcast_state === 3,
                }">{{ courseStatus[item.live_broadcast_state] }}</div>
            </div>
            <p class="user-courses-item-title">{{ item.title }}</p>
            <p class="user-courses-item-desp">{{ item.short_desp }}</p>
            <ct-progressBar :total="item.subclass_count" :current="item.end_subclass_count"></ct-progressBar>
            <p class="user-courses-item-count">{{ item.subclass_count > 1 ? item.subclass_count + ' Lessons' : '1 Lesson'  }}</p>
          </div>
        </li>
      </ul>
      <v-pagination
        :style="{
          visibility: totalPage > 1 ? 'visible' : 'hidden'
        }"
        class="my-courses-pagination"
        :total="totalPage"
        :page="current"
        @change-page="changePage"
        ></v-pagination>
    </div>
  </div>
</template>

<script>
import api from '../../../api'
import Pagination from '@ca/components/Pagination.vue'
import { courseStatus } from '@ca/constants/index'
import { mapGetters } from 'vuex'
import { vueAppPassportDomin } from '@ca/constants/variables'
export default {
  name: 'UserCourses',
  components: {
    'v-pagination': Pagination
  },
  data () {
    return {
      myCourses: [],
      courseStatus,
      hasFetched: false,
      total: 0,
      current: 1,
      page_size: 10,
      fetched: false
    }
  },
  methods: {
    changePage (page) {
      if (!this.fetched) return
      this.fetched = false
      api.getMyCourses({
        params: {
          page,
          page_size: this.page_size
        }
      }).then(res => {
        if (res.data && res.data.code === 1) {
          this.myCourses = this.formatData(res.data.data.list)
          this.total = res.data.data.total
        } else if (res.data.code === 100000) {
          window.location.href = vueAppPassportDomin + '/login?return_url=' + window.location.href
        } else {
          this.myCourses = []
        }
        this.fetched = true
      })
    },
    goCourseDetail (course) {
      this.$router.push({
        name: 'userCourseDetail',
        params: {
          goods_id: course.goods_id
        }
      })
    },
    formatData (o) {
      o = JSON.parse(JSON.stringify(o))
      o.forEach(el => {
        el.title = el.title || '看到此消息请为此大课配置标题'
        el.cover = el.cover || this.defaultCover
      })
      return o
    }
  },
  mounted () {
    api.getMyCourses({
      params: {
        page: 1,
        page_size: 20
      }
    }).then(res => {
      if (res.data && res.data.code === 1) {
        this.myCourses = this.formatData(res.data.data.list)
        this.total = res.data.data.total
      } else if (res.data.code === 100000) {
        window.location.href = vueAppPassportDomin + '/login?return_url=' + window.location.href
      } else {
        this.myCourses = []
      }
      this.hasFetched = true
      this.fetched = true
    })
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
    truelyEmpty () {
      return this.hasFetched && this.myCourses.length === 0
    },
    totalPage () {
      return Math.ceil(this.total / this.page_size) || 1
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-courses-container {
    color: #1A3D5E;
    .user-courses-empty-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 80vh;
      img {
        width: 211px;
        margin-bottom: 33px;
      }
      p {
        font-size:14px;
        font-weight:400;
        color:rgba(186,196,206,1);
        line-height:14px;
      }
    }
    .user-courses-item {
      padding: 18px 0;
      border-radius:2px;
      border:1px solid rgba(218,224,229,1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 16px;
      cursor: pointer;
      box-shadow: 0px 2px 16px 0px transparent;
      transition: all .2s ease-in-out;
      &:hover {
        box-shadow: 0px 2px 16px 0px rgba(35, 62, 114, 0.07);
        border:1px solid transparent;
      }
      .user-courses-item-img {
        width: 298px;
        height: 168px;
        margin-left: 32px;
        img {
          width: 100%;
          height: 100%;
          vertical-align: middle;
        }
      }
      .user-courses-item-infos {
        flex: 1;
        overflow: hidden;
        padding: 0 32px 0 40px;
        .user-courses-item-status {
          margin-bottom: 8px;
          > div {
            font-size:12px;
            padding: 6px;
            font-weight:500;
            line-height:14px;
            display: inline-block;
            &.notstart {
              color:#FACB58;
              background: #FEF9EE;
            }
            &.half {
              color:rgba(55,202,215,1);
              background: #EBF9FA;
            }
            &.total {
              background: #EFF4FA;
            }
          }
        }
        .user-courses-item-title {
          font-size:20px;
          font-weight:500;
          line-height:28px;
          margin-bottom: 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .user-courses-item-desp {
          font-size:14px;
          font-weight:400;
          color:rgba(118,139,158,1);
          line-height:22px;
          margin-bottom: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .user-courses-item-count {
          font-size:12px;
          line-height:12px;
          margin-top: 8px;
          text-align: right;
        }
      }
    }
    .my-courses-pagination {
      text-align: center;
      margin: 40px 0 50px;
    }
  }
</style>
